export default {
    title: "404",
    text:
        "Oh snap! You ran into panda! QUICK - run away before he wrecks your HP!",
}